export default __webpack_public_path__ + "static/media/conveyor-system-icon.28b52bac.svg";